import type { ProjectListItem } from '@clarix/shared-types';

/**
 * Sort sidebar projects: pinned first (in pin order), then custom-ordered, then alphabetical.
 */
export function sortSidebarProjects(
  projects: ProjectListItem[],
  pinnedIds: string[],
  customOrder: string[],
): ProjectListItem[] {
  const pinnedSet = new Set(pinnedIds);
  const orderMap = new Map(customOrder.map((id, idx) => [id, idx]));

  const pinned: ProjectListItem[] = [];
  const unpinned: ProjectListItem[] = [];

  for (const p of projects) {
    if (pinnedSet.has(p.id)) {
      pinned.push(p);
    } else {
      unpinned.push(p);
    }
  }

  // Sort pinned by their order in pinnedIds
  pinned.sort((a, b) => pinnedIds.indexOf(a.id) - pinnedIds.indexOf(b.id));

  // Sort unpinned: custom order first, then alphabetical
  unpinned.sort((a, b) => {
    const aIdx = orderMap.get(a.id);
    const bIdx = orderMap.get(b.id);
    const aHasOrder = aIdx !== undefined;
    const bHasOrder = bIdx !== undefined;

    if (aHasOrder && bHasOrder) return aIdx - bIdx;
    if (aHasOrder) return -1;
    if (bHasOrder) return 1;
    return a.name.localeCompare(b.name);
  });

  return [...pinned, ...unpinned];
}
